import api from './client';

export default class BaseModel {
  path = '';

  get = async () => api.get(this.path).json();

  create = async (payload) => api.post( `${this.path}`, { json: payload }).json();

  update = async (payload) => api.put( `${this.path}`, { json: payload }).json();

  deleteById = async (id) => api.delete( `${this.path}/${id}`);

  deleteMany = async (payload) => api.delete( `${this.path}`, { json: payload }).json();
}
